<template>
    <v-footer app
      color="primary lighten-1"
      padless
    >
      <v-row
        justify="center"
        no-gutters
      >
      <v-btn
        v-for="link in links"
        :key="link.name"
        :href="link.href"
        color="white"
        text
        rounded
        class="my-2"
      >
      {{ link.name }}
      </v-btn>
        <v-col
          class="primary lighten-2 py-4 text-center white--text"
          cols="12"
        >
          {{ new Date().getFullYear() }} — <strong>InTheSuburbs.com.au</strong>
        </v-col>
      </v-row>
    </v-footer>
  </template>

<script>
  export default {
    name: "Footer",
    data: () => ({
      links: [
          {
            name: "Home",
            href: "/",
          },
          {
            name: "Contact",
            href: "/contact/",
          },
          {
            name: "Index",
            href: "/Index/",
          },
      ],
    }),
  }
</script>